import React, { Component } from 'react';
import T from 'prop-types';
import { Col, ControlLabel, FormGroup, HelpBlock, Row } from 'react-bootstrap';

/**
 * Credits: Dima Bukhal (https://github.com/dima-bu/react-time-input)
 */
class HoursMinutesInput extends Component {
    constructor(props) {
        super(props);
        this.state = {
            time: this.props.initTime || '',
        };
        this.lastVal = '';
    }

    componentDidMount() {
        if (!this.props.disabled && this.props.mountFocus) {
            setTimeout(() => {
                this._input.focus();
            }, 0);
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.initTime) {
            this.onChangeHandler(nextProps.initTime);
        }
    }

    componentDidUpdate() {
        if (this.props.mountFocus) {
            setTimeout(() => {
                this._input.focus();
            }, 0);
        }
    }

    getType() {
        if (this.props.type) {
            return this.props.type;
        }
        return 'tel';
    }

    isValid(val) {
        let regexp = /^\d{0,10}?:?\d{0,2}$/,
            valArr = [];

        const [hoursStr, minutesStr] = val.split(':');

        if (!regexp.test(val)) {
            return false;
        }

        const hours = Number(hoursStr);
        const minutes = Number(minutesStr);

        const isValidHour = h => Number.isInteger(h) && h >= 0;
        const isValidMinutes = m => (Number.isInteger(m) && hours >= 0) || Number.isNaN(m);
        if (!isValidHour(hours) || !isValidMinutes(minutes)) {
            return false;
        }

        if (minutes < 10 && Number(minutesStr[0]) > 5) {
            return false;
        }

        if (valArr.indexOf(':')) {
            valArr = val.split(':');
        } else {
            valArr.push(val);
        }

        // check mm and HH
        if (
            valArr[1] &&
            valArr[1].length &&
            (parseInt(valArr[1], 10) < 0 || parseInt(valArr[1], 10) > 59)
        ) {
            return false;
        }

        return true;
    }

    onChangeHandler(val) {
        if (val === this.state.time) {
            return;
        }
        if (this.isValid(val)) {
            this.lastVal = val;

            this.setState({
                time: val,
            });

            this.props.onTimeChange(val);
        }
    }

    render() {
        const { errorMessage, label, noBottomMargin = false } = this.props;

        return (
            <FormGroup
                controlId={this.props.name}
                validationState={errorMessage ? 'error' : null}
                style={{ marginBottom: noBottomMargin ? 0 : null }}
            >
                <Row style={{ marginBottom: noBottomMargin ? 0 : 10 }}>
                    <Col componentClass={ControlLabel} sm={4} style={{ marginTop: 10 }}>
                        {label}
                    </Col>
                    <Col sm={8} style={{ marginTop: 5 }}>
                        <input
                            min={this.props.min}
                            maxLength={this.props.maxLength}
                            name={this.props.name}
                            className={`${this.props.className} form-control`}
                            type={this.getType()}
                            disabled={this.props.disabled || this.props.readOnly}
                            placeholder={this.props.placeholder}
                            value={this.state.time}
                            onChange={e => this.onChangeHandler(e.target.value)}
                            onFocus={
                                this.props.onFocusHandler
                                    ? e => this.props.onFocusHandler(e)
                                    : undefined
                            }
                            onBlur={
                                this.props.onBlurHandler
                                    ? e => this.props.onBlurHandler(e)
                                    : undefined
                            }
                            ref={c => (this._input = c)}
                        />
                        {errorMessage && <HelpBlock>{errorMessage}</HelpBlock>}
                    </Col>
                </Row>
            </FormGroup>
        );
    }
}

HoursMinutesInput.defaultProps = {
    placeholder: ' ',
};

HoursMinutesInput.propTypes = {
    initTime: T.string,
    onTimeChange: T.func.isRequired,
};

export default HoursMinutesInput;
